/**
 * 脱敏国际化手机号
 * @param {string} tel
 * @returns 脱敏后的手机号
 */
import parsePhoneNumber from 'libphonenumber-js';

const DEFAULT_PREFIX = 'CN';
export function formatTel(tel) {
    const phoneNumber = parsePhoneNumber(tel, DEFAULT_PREFIX);
    if (!phoneNumber) {
        // 手机号码为空的情况
        return {
            isValid: false,
            countryCallingCode: '86',
            nationalNumber: '',
        };
    }
    return {
        isValid: phoneNumber.isValid(),
        ...phoneNumber,
    };
}

function entryptNationalTel(tel) {
    const { countryCallingCode, nationalNumber } = formatTel(tel || '');
    const MIN_LENTH = 5;
    const MAX_LENTH = 17;
    if (nationalNumber.length < MIN_LENTH || nationalNumber.length > MAX_LENTH || typeof tel !== 'string') {
        console.warn('号码格式不正确');
        return tel;
    }
    if (nationalNumber.length <= 5) {
        return `+${countryCallingCode}${tel[0]}****${nationalNumber.slice(-1)}`;
    }
    if (nationalNumber.length > 5 && nationalNumber.length < 11) {
        return `+${countryCallingCode}${nationalNumber.slice(0, 3)}****${nationalNumber.slice(-2)}`;
    }
    return `+${countryCallingCode}${nationalNumber.slice(0, 3)}****${nationalNumber.slice(-4)}`;
}

function isNationalTel(tel) {
    return tel.startsWith('+');
}

export function encryptTel(tel) {
    if (isNationalTel(tel)) {
        return entryptNationalTel(tel);
    }
    return `${tel.slice(0, 3)}****${tel.slice(-4)}`;
}
